export default __webpack_public_path__ + "static/media/cpu.16b64a17.svg";